import { FLEET_VEHICLE_LIST_DETAILS } from '~/common/models/pages/fleetPages.model';
import { RouteName } from '~/common/models/route.model';
import { makeRoutePathLite } from '~/common/utils/route/route.utils';

/**
 * Type for the asset URL builder function
 */
export type BuildAssetUrlFn = (assetId: string) => string;

/**
 * Builds an asset URL using organization-based routing if available,
 * otherwise falls back to legacy routing.
 *
 * This is a pure utility function with no React dependencies.
 * For React components, prefer using `useBuildAssetUrl` hook from
 * `~/common/hooks/useBuildAssetUrl` which wraps this function.
 *
 * @param assetId - The asset/vehicle ID
 * @param organizationsId - Optional organization ID
 * @param isFeatureFlagEnabled - Whether the vehicle details routing flag is enabled
 * @returns The asset detail URL
 */
export const buildAssetUrl = (
  assetId: string,
  organizationsId?: string,
  isFeatureFlagEnabled?: boolean
): string => {
  if (!assetId) {
    return '#';
  }

  if (organizationsId && isFeatureFlagEnabled) {
    return makeRoutePathLite({
      routeName: RouteName.ORGANIZATIONS_VEHICLES_DETAILS,
      params: {
        organizationsId,
        assetsId: assetId,
      },
    });
  }

  // Fallback to legacy route - use URLSearchParams for proper encoding
  const params = new URLSearchParams({ assetsId: assetId });
  return `${FLEET_VEHICLE_LIST_DETAILS}?${params.toString()}`;
};
